export const getIsDarkTheme = (state) => state.theme.isDark;
